/**
 * 高级报表服务
 * 处理高级报表相关的 API 调用
 */

import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/api';

/**
 * 高级报表服务
 */
const advancedReportService = {
  /**
   * 获取总剩余课时数
   * @returns {Promise<Object>}
   */
  async getTotalRemainingHours() {
    return apiClient.get(API_ENDPOINTS.ADVANCED_REPORT.TOTAL_REMAINING_HOURS);
  },

  /**
   * 获取月度消课时趋势
   * @param {Object} params - 查询参数
   * @param {number} params.months - 要查询的月份数量，默认4个月
   * @returns {Promise<Object>}
   */
  async getMonthlyConsumptionTrend(params = {}) {
    return apiClient.get(API_ENDPOINTS.ADVANCED_REPORT.MONTHLY_CONSUMPTION_TREND, {
      months: 6,
      ...params,
    });
  },

  /**
   * 获取学生课时排名
   * @param {Object} params - 查询参数
   * @param {string} params.order - 排序方式 ('desc' 或 'asc')，默认'desc'
   * @param {string} params.student_type - 学生类型，默认'在学'
   * @returns {Promise<Object>}
   */
  async getStudentHoursRanking(params = {}) {
    return apiClient.get(API_ENDPOINTS.ADVANCED_REPORT.STUDENT_HOURS_RANKING, {
      order: 'desc',
      student_type: '在学',
      ...params,
    });
  },

  /**
   * 获取考勤记录
   * @param {Object} params - 查询参数
   * @param {number} params.student_id - 学生ID（可选）
   * @param {number} params.course_id - 课程ID（可选）
   * @param {number} params.limit - 返回记录数量限制，默认50
   * @returns {Promise<Object>}
   */
  async getAttendanceRecords(params = {}) {
    return apiClient.get(API_ENDPOINTS.ADVANCED_REPORT.ATTENDANCE_RECORDS, {
      limit: 50,
      ...params,
    });
  },

  /**
   * 获取特定学生的课程列表
   * @param {number} studentId - 学生ID
   * @returns {Promise<Object>}
   */
  async getStudentCourses(studentId) {
    return apiClient.get(`${API_ENDPOINTS.ADVANCED_REPORT.STUDENT_COURSES}`, {
      student_id: studentId,
    });
  },

  /**
   * 获取报表汇总数据
   * @param {Object} params - 查询参数
   * @param {number} params.months - 要查询的月份数量，默认4个月
   * @returns {Promise<Object>}
   */
  async getReportSummary(params = {}) {
    return apiClient.get(API_ENDPOINTS.ADVANCED_REPORT.SUMMARY, {
      months: 6,  // 修改为6个月
      ...params,
    });
  },

  /**
   * 获取课时不足的学生列表
   * @param {Object} params - 查询参数
   * @param {number} params.threshold - 课时阈值，默认2（返回剩余课时小于此值的学生）
   * @param {string} params.student_type - 学生类型，默认'在学'
   * @returns {Promise<Object>}
   */
  async getLowHoursStudents(params = {}) {
    return apiClient.get(API_ENDPOINTS.ADVANCED_REPORT.LOW_HOURS_STUDENTS, {
      threshold: 2,
      student_type: '在学',
      ...params,
    });
  },
};

export default advancedReportService;